module.exports = __webpack_public_path__ + "static/3-f87945d7f2915715edc6e5595db8f2da.gif";